import { PDFTemplateType } from "../enums/pdf-template-type.enum";


export class PdfTemplate {
  id: number;
  name: string;
  templateType: PDFTemplateType;
  thumbnail: string;
}
